import { SocialMediaPlatform } from './social-media';

export type CommunityItem = {
  created_at: number;
  updated_at: number;
  extra: Record<string, any>;
  post_uuid: string;
  user: PostUser;
  content: Content;
  likes_count: number;
  views_count: number;
  posted_at: number;
  pinned_at: number | null;
  is_active: boolean;
  is_liked_by_me: boolean;
  is_saved?: boolean;
  post_type: PostType;
  original_platform?: Platform;
  external_id?: string;
  liked_by: ShortLikeUser[];
  comments_count?: number;
  user_comment?: UserComment;
};

export type UserComment = {
  comment_uuid: string;
  user_uuid: string;
  post_uuid: string;
  replied_to: string | null;
  user: PostUser;
  likes_count: number;
  is_liked_by_me: boolean;
  content: UserCommentContent;
  created_at: number;
  updated_at: number;
  replied_comment: UserComment | null;
};

export type UserCommentContent = {
  title: string | null;
  text: string;
  social_media: SocialMedia | null;
  repost: Repost | null;
  images: string[];
  files: string[];
  links: string[];
  videos: string[];
};

export type UserLogo = {
  id: number;
  url: string;
  name?: string;
  owner_id?: string;
  relation?: string;
  width?: number | null;
  height?: number | null;
  file_size?: number | null;
  original_name?: string | null;
};

export type PostUser = {
  user_uuid: string;
  username: string;
  types: CommunityUserTypes;
  avatar_url: string;
  user_logo: UserLogo | string | null;
  user_homepage: string | null;
};

export type CommunityUserTypes = {
  id: number;
  name: string;
};

export interface ShortLikeUser {
  passport_uuid: string;
  username: string;
  avatar_url: string;
}

export interface CommunityShortUser {
  user_uuid: string;
  username: string;
  types: CommunityUserTypes[];
  description: string;
  logo: string | null;
  homepage: string | null;
  avatar_url: string | null;
}

export type Platform = {
  slug: SocialMediaPlatform;
  name: string;
};

export type PostType = {
  slug: PostTypes;
  text: string;
};

export enum PostTypes {
  post = 'post',
  postPaid = 'post_paid',
  likedVideo = 'liked_video',
  likedPlaylist = 'liked_playlist',
  socialPost = 'social_media_post',
  postedVideo = 'posted_video',
  repost = 'repost',
  followedPlaylist = 'followed_playlist',
  followedUser = 'followed_user',
  followedChannel = 'followed_channel',
}

export type Content = {
  title: string;
  text: string;
  social_media?: SocialMedia;
  repost?: Repost;
  community_repost?: Repost;
  images?: Image[];
  links?: Link[];
  files?: PostFile[];
  videos?: Video[];
};

export type SocialMedia = {
  external_id: string;
  external_url: string;
  external_username: string;
  external_user_url: string | null;
};

export type Repost = {
  source: Source;
  original: OriginalSource | null;
};

export type Image = {
  image_url: string;
  image_id: number;
};

export type Link = {
  link_text: string;
  link_image_id: number;
  link_image_url: string;
  link_url: string;
};

export type PostFile = {
  file_id: number;
  file_url?: string;
  file_name?: string;
  file_size?: number;
};

export type Video = {
  preview_id: number;
  preview_url: string;
  video_id: number;
  video_external_id: number;
  video_url: string;
  trailer_id: number;
  trailer: string;
  video: string;
};

export interface Source {
  source_uuid: any;
  source_name: string;
  source_url: string;
  source_image: SourceImage;
  source_user?: CommunityShortUser | null;
}

export interface SourceImage {
  image_id: string;
  image_url: string;
}

export type OriginalSource = {
  original_id: string;
  original_type: PostTypes;
  original_url: string | null;
  original_uuid: string | null;
  original_type_text: string | null;
};
